import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import { CompanyRegisterFormProps as Props } from './types';
import { useFlash } from '../../../hooks/useFlash';
import { jQueryScrollTo } from '../../../libs/scrollUtils';
import { CompanyForm, PlanPurchaseForm, UserAuthForm } from '../../../types/companyRegisterForm';

export const Component: FunctionComponent<Props> = (props) => {
  const { flash, flashType, flashMessage, handleFlash } = useFlash();
  const [section, setSection] = useState<'profile' | 'plan'>('profile');
  const [company, setCompany] = useState<CompanyForm>({
    name: '',
    url: '',
    staffName: '',
    phoneNumber: '',
    riyohoho: '',
    oshiri: '',
  });
  const [userAuth, setUserAuth] = useState<UserAuthForm>({
    email: '',
    password: '',
    passwordConfirmation: '',
  });
  const [planPurchase, setPlanPurchase] = useState<PlanPurchaseForm>({
  contractPlanId: null,
  invitationCode: '',
  paymentMethodId: 1,
  companyName: '',
  department: '',
  inCharge: '',
  zipCode01: '',
  zipCode02: '',
  address01: '',
  address02: '',
  email: '',
  emailSubFirst: '',
  emailSubSecond: '',
  agreement: false
  });

  const handleSectionChange = useCallback(
    (newSection: 'profile' | 'plan') => {
      setSection(newSection);
      jQueryScrollTo('.wrap');
    },
    []
  );

  const handleChange = (section: 'company' | 'userAuth' | 'planPurchase', field: string, value: string | boolean| number) => {
    if (section === 'company') {
      setCompany(prev => ({ ...prev, [field]: value }));
    } else if (section === 'userAuth') {
      setUserAuth(prev => ({ ...prev, [field]: value }));
    } else {
      setPlanPurchase(prev => ({ ...prev, [field]: value }));
    }
  };

  const syncSectionWithPath = useCallback(() => {
    const currentPath = window.location.pathname;
    setSection(currentPath === '/companies/new/plan' ? 'plan' : 'profile');
  }, []);

  // sectionが変わったらpathを更新
  useEffect(() => {
    const path = section === 'plan' ? '/companies/new/plan' : '/companies/new/profile';
    if (window.location.pathname !== path) {
      window.history.pushState({}, '', path);
    }
  }, [section]);

  // 初期 & popstate時に section をURLから取得して同期
  useEffect(() => {
    syncSectionWithPath();
    window.addEventListener('popstate', syncSectionWithPath);
    return () => {
      window.removeEventListener('popstate', syncSectionWithPath);
    };
  }, [syncSectionWithPath]);

  return (
    <Presentation
      {...props}
      flash={flash}
      flashType={flashType}
      flashMessage={flashMessage}
      handleFlash={handleFlash}
      section={section}
      company={company}
      userAuth={userAuth}
      planPurchase={planPurchase}
      handleSectionChange={handleSectionChange}
      handleChange={handleChange}
    />
  );
};
